module.exports = __webpack_public_path__ + "img/crazy.f8451ac7.gif";